import { Skeleton } from "@nextui-org/react"

export type TableRowLoaderProps = {
  isEven?: boolean
}

export const TableRowLoader = ({ isEven }: TableRowLoaderProps) => {
  return (
    <div
      className={`flex w-full items-center border-b border-gray-100 py-4 ${isEven ? "bg-gray-50" : "bg-white"}`}
    >
      <div className="w-[25%] px-3">
        <Skeleton className="h-8 w-full rounded" />
      </div>
      <div className="w-[25%] px-3">
        <Skeleton className="h-8 w-full rounded" />
      </div>
      <div className="w-[25%] px-3">
        <Skeleton className="h-8 w-full rounded" />
      </div>
      <div className="w-[25%] px-3">
        <Skeleton className="h-8 w-full rounded" />
      </div>
    </div>
  )
}
